<div class="loading" *ngIf="loader"></div>

<form [formGroup]="rateForm">
    <fieldset aria-required="true">
        <div class="row no-gutters content_top_margin">
            <div class="col-12">
                <legend class="sectionHeading_one bot_spa_aft_sect_heading legend_display" id="yourOnline"
                    [innerHTML]="'online-rate.title'|translate">
                </legend>
            </div>
        </div>
        <div class="row no-gutters bot_spa_aft_sect_heading">
            <ng-container *ngFor="let rate of res.products;let i=index">
                <div class="col-md-6 col-12  p-1">
                    <label [for]="'rates'+i">
                        <div class="m-2 p-3 d-flex flex-column justify-content-center"
                            [ngClass]="(borderColorY&&selectedValue==rate.productDetails.rates[0].rate[0])?'selectedCard':'cardCls'">
                            <span class="text-center productName bot_spa_aft_sect_heading" id="prodName">
                                <ng-container *ngIf="currentLang!=null&&currentLang==currLangEn">
                                    {{rate.productDetails.metaData.longName[0].name}}
                                </ng-container>
                                <ng-container *ngIf="currentLang!=null&&currentLang==currLangFr">
                                    {{rate.productDetails.metaData.longName[1].name}}
                                </ng-container>
                            </span>
                            <span class="text-center productRate bot_spa_aft_sect_heading">
                                <div class="nobtn">
                                    <input type="radio" tabindex="0"  [id]="'rates'+i" formControlName="fixedRate"
                                        class="hideinp" aria-describedby="rateHelp" name="rate"
                                        [value]="rate.productDetails.rates[0].rate[0]"
                                    >
                                </div>
                                <span
                                    [id]="'ratevarVal'+j">{{format(rate.productDetails.rates[0].rate[0].rateValue)}}%<sup>2</sup></span>
                                    <div class="primeRate" [ngClass]="rate.productDetails.metaData.rateType=='V'?'d-block':'d-none'"
                                        [innerHTML]="'online-rate.primeText'|translate:{switchDiscount:format(rate.productDetails.rates[0].rate[0].discount)}"
                                        id="discountamortless">
                                    </div>
                            </span>
                            <span class="text-center productTerm">{{'online-rate.amortization'|translate}}
                                {{'online-rate.lessYears'|translate}}
                            </span>
                        </div>
                    </label>
                </div>
                <div class="col-md-6 col-12  p-1">
                    <label [for]="'rates1'+i">
                        <div class="m-2 p-3 d-flex flex-column justify-content-center"
                            [ngClass]="(borderColorY&&selectedValue==rate.productDetails.rates[0].rate[1])?'selectedCard':'cardCls'">
                            <span class="text-center productName bot_spa_aft_sect_heading">
                                <ng-container *ngIf="currentLang!=null&&currentLang==currLangEn">
                                    {{rate.productDetails.metaData.longName[0].name}}
                                </ng-container>
                                <ng-container *ngIf="currentLang!=null&&currentLang==currLangFr">
                                    {{rate.productDetails.metaData.longName[1].name}}
                                </ng-container>
                            </span>
                            <span class="text-center productRate bot_spa_aft_sect_heading">
                                <div class="nobtn">
                                    <input type="radio" tabindex="0"  [id]="'rates1'+i"  formControlName="fixedRate"
                                        class="hideinp" aria-describedby="rateHelp" name="rate"
                                        [value]="rate.productDetails.rates[0].rate[1]">
                                </div>
                                <span
                                    [id]="'ratevarVal'+j">{{format(rate.productDetails.rates[0].rate[1].rateValue)}}%<sup>2</sup></span>
                                    <div class="primeRate" [ngClass]="rate.productDetails.metaData.rateType=='V'?'d-block':'d-none'" [innerHTML]="'online-rate.primeText'|translate:{switchDiscount:format(rate.productDetails.rates[0].rate[0].discount)}"
                                        id="discountamortless">
                                    </div>
                            </span>
                            <span class="text-center productTerm ">{{'online-rate.amortization'|translate}}
                                {{'online-rate.moreYears'|translate}}
                            </span>
                        </div>
                    </label>
                </div>
            </ng-container>
        </div>
        <div class="row no-gutters bot_spa_aft_sect_heading" [ngClass]="displayValidation ? 'd-block' : 'd-none'">
            <div class="col-12">
                <small id="rateHelp" class="d-flex align-items-start errorMsg mt-1"> <img aria-hidden="true"
                        src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
                        {{ 'co-applicant-selection.validation' | translate
                        }}
                    </span>
                </small>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-12">
                <span>{{'online-rate.termsText'|translate}} </span>
                <button class="note_link infoButton">
                    <span class=" pl-0  note_link" aria-labelledby="emailTextAcc"
                        (click)="openTerms(popContent)"><u>{{'online-rate.termsandconditions'|translate}}</u></span></button>
            </div>
        </div>
        <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
            <div class="col-12 d-flex d-md-block flex-column-reverse">
                <cancel-button></cancel-button>
                <button type="button" class="common_btn saveNextBtn_features space_between_button"
                    (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
            </div>
        </div>
    </fieldset>
</form>


<ng-template #popContent>
        <div class="d-flex justify-content-between">
            <div></div>
            <button type="button" style="border: 0px;" class="close popUpClose" (click)="close();" id="clsTooltipa"
                aria-label="Close" data-toggle="tooltip">

                <span class="float-right danger" aria-hidden="true">&times;</span>
                <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
            </button>
        </div>
        <ng-container *ngIf="bilingualApplicant; else nonBilingualContent">
            <mat-tab-group>
                <mat-tab label="French">
                    <ng-container
                        *ngTemplateOutlet="bilingual;context:{lang:'_fr',date:formatted_fr,clickHere:clickHere_fr}"></ng-container>
                </mat-tab>
                <mat-tab label="English">
                    <ng-container
                        *ngTemplateOutlet="bilingual;context:{lang:'',date:formatted,clickHere:clickHere}"></ng-container>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
        <ng-template #nonBilingualContent>
            <ng-container
                *ngTemplateOutlet="bilingual;context:{lang:'',date:formatted,clickHere:clickHere}"></ng-container>
        </ng-template>
   
</ng-template>
<ng-template #bilingual let-lang="lang" let-date="date" let-clickHere="clickHere">
    <div class="modal-body modalContent">
        <ng-container>
            <div>{{'online-rate.termsandconditionstext1'+lang | translate:{date:
                date} }} </div>
            <div class="pt-3">{{'online-rate.termsandconditionstext2'+lang | translate }}</div>
            <div class="pt-3">{{'online-rate.termsandconditionstext3'+lang | translate:{date:
                date} }}</div>
            <div class="pt-3">{{'online-rate.termsandconditionstext4'+lang | translate:{date:
                date} }}
                <a [href]="clickHere" class=" pr-0 landingSummaryLink" target="_blank" data-toggle="tooltip"
                    data-placement="top">
                    <span class="note_link"><u>{{'online-rate.clickHere'+lang|translate}}</u></span>
                </a>
            </div>
        </ng-container>
    </div>
</ng-template>